import React, { Fragment, useState,useEffect } from 'react';
import { Row, Col, Container, Card, Button } from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import { Navigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCirclePlus, faAlignJustify } from '@fortawesome/free-solid-svg-icons'
import '../../../styles/diario.scss';


function HomeLoggedAtosScreen() {
    const [cad, setCad] = useState(false)
    const [listar, setListar] = useState(false)
    const [adm, setAdm] = useState(false)
    const nome = localStorage.getItem('nome');
    const nivel = localStorage.getItem('nivel');

    const verNivel = (nivel) => {
        if (nivel === "Administrador") {
            setAdm(true)
        }
    }
    useEffect(() => {
        verNivel(nivel)
    }, [nivel])

    if(listar) {
        return <Navigate to={{pathname: '/restrito/atos/listar'}}/>
    }

    if(cad) {
        return <Navigate to={{pathname: '/restrito/atos/cadastrar'}}/>
    }

    return (
        <Fragment>
            <Head titulo="Transparência - Atos Oficiais do Governo" />
            <HeaderLogged />
            <Container>
                <h5>Bem vindo, {nome}, o que deseja fazer?</h5><br/>
                <Row xs={1} lg={2}>
                    <Col>
                        <Card className='card-list' onClick={e => setCad(true)}>
                            <Card.Body>
                                <Row xs={1}>
                                    <Col>
                                        <Row xs={2}>
                                            <Col xs={3}>
                                                <FontAwesomeIcon className='icon-cad' icon={faFileCirclePlus} />
                                            </Col>
                                            <Col xs={9}>
                                                <p className='titulo-lei'>Cadastrar Ato Oficial</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className='card-list' onClick={e => setListar(true)}>
                            <Card.Body>
                                <Row xs={1}>
                                    <Col>
                                        <Row xs={2}>
                                            <Col xs={3}>
                                                <FontAwesomeIcon className='icon-cad' icon={faAlignJustify} />
                                            </Col>
                                            <Col xs={9}>
                                                <p className='titulo-lei'>Listar Atos Oficiais</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                {adm ?
                    <Fragment>
                        <br /><br />
                        <Link to={'/restrito'}>
                            <Button variant="danger" type="button">
                                Voltar
                            </Button>
                        </Link>
                    </Fragment> : ''}
            </Container>
            <Footer />
        </Fragment>
    );
}

export default HomeLoggedAtosScreen;